import {Component, Host, Prop, h, forceUpdate} from "@stencil/core";

import {i18nProvider} from "@trumpf/ux.i18n";
import {translations} from "./i18n";

import {Header, CaptionedGroup} from "./notification-center-sub-components";

import {notificationsStore as store} from "../stores/notificationsStore";
import type {Stage} from "../stores/apiService";

const {i18n} = i18nProvider;

//TODO update correct urls
const defaultSettingsUrl: Record<Stage, string> = {
	INT: "https://cms.trumpf.com.dev.tru/go/notification/settings/",
	QA: "https://www-q.trumpf.com/go/notification/settings/",
	PROD: "https://trumpf.com/go/notification/settings/",
};

/**
 * Notification center component to display new notifications.
 */
@Component({
	tag: "uxn-notification-center",
	styleUrl: "notification-center.scss",
	shadow: false,
})
export class NotificationCenter {
	/** url to custom notification settings */
	@Prop() customSettingsUrl: string = "";
	/** stage */
	@Prop() stage: Stage = "PROD";
	/** language code */
	@Prop() locale: string = "de_DE";
	/** toggle debugging */
	@Prop() debug: boolean = false;

	#i18nSubscriberId: string;

	get #settingsUrl() {
		return this.customSettingsUrl || defaultSettingsUrl[this.stage];
	}

	async componentWillLoad() {
		this.#customTranslation();
		await i18nProvider.changeLanguage(this.locale);
		this.#i18nSubscriberId = i18nProvider.subscribe(() => forceUpdate(this)); //TODO check if this is needed
	}

	async componentDidLoad() {
		await store.init({
			locale: this.locale,
			stage: this.stage.toUpperCase() as Stage,
			debug: this.debug,
		});
	}

	disconnectedCallback() {
		i18nProvider.unsubscribe(this.#i18nSubscriberId);
		store.reset();
	}

	#customTranslation() {
		Object.entries(translations).forEach(([language, bundle]) => i18n.addResourceBundle(language, "notifications", bundle));

		i18n.on("languageChanged", (lng) => {
			if (Object.keys(translations).includes(lng)) return;

			const lngCode = lng.split("_")[0];
			const fallbackLng = Object.keys(translations).find((key) => key.startsWith(lngCode));
			if (fallbackLng) i18n.changeLanguage(fallbackLng); //TODO fix async
		});
	}

	render() {
		// eslint-disable-next-line @typescript-eslint/no-unsafe-return
		return (
			<Host class="uxn-notification-center">
				<Header settingsURL={this.#settingsUrl} isLoading={store.isLoading} hasFailed={store.hasFailedInitializing || store.hasFailedGet} count={store.count} />
				<CaptionedGroup caption="today" notifications={store.notifications.filter((notification) => notification.dateGroup === "today")} />
				<CaptionedGroup caption="yesterday" notifications={store.notifications.filter((notification) => notification.dateGroup === "yesterday")} />
				<CaptionedGroup caption="older" notifications={store.notifications.filter((notification) => notification.dateGroup === "older")} />
			</Host>
		);
	}
}
